import { SubmitGroupItemModel, TextInputModel } from '@libs/form/models';

export const AliasInputData: TextInputModel = {
  type: 'text',
  name: 'alias',
  label: 'Bezeichnung Kundennummer',
  attributes: {
    spellcheck: false,
  },
};

export const SubmitGroupData: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    {
      theme: 'filled',
      name: 'save',
      label: 'Bezeichnung speichern',
    },
  ],
};
